import React, { useContext, useState, useRef, useMemo } from "react";
import { AttachFile, AddPhotoAlternateOutlined } from "@mui/icons-material";
import { AuthContext } from "../../context/AuthContext";
import { ChatContext } from "../../context/ChatContext";
import { Send } from "@mui/icons-material";
import { v4 as uuid } from "uuid";
import {
  arrayUnion,
  Timestamp,
  updateDoc,
  doc,
  serverTimestamp,
  getDoc,
  setDoc,
} from "firebase/firestore";
import parse from "html-react-parser";
import { db, storage } from "../../firebase";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";

export default function Input() {
  const [text, setText] = useState("");
  const [img, setImg] = useState(null);

  const { currentUser } = useContext(AuthContext);
  const { data, members } = useContext(ChatContext);

  const handleKey = (e) => {
    e.code === "Enter" && handleSend();
  };
  const handleSend = async () => {
    if (!text && !img) return;
    if (img) {
      const storageRef = ref(storage, uuid());
      const uploadTask = uploadBytesResumable(storageRef, img);
      uploadTask.on(
        (error) => {
          console.error(error);
          console.log("image-upload-error: ",error.code);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
            await updateDoc(doc(db, "chats", data.chatId), {
              messages: arrayUnion({
                id: uuid(),
                text,
                senderId: currentUser.uid,
                date: Timestamp.now(),
                img: downloadURL,
              }),
            });
          });
        }
      );
    } else {
      
      await updateDoc(doc(db, "chats", data.chatId), {
        messages: arrayUnion({
          id: uuid(),
          text,
          senderId: currentUser.uid,
          date: Timestamp.now(),
        }),
      });
    }
    
    if (data.user.isGroup) {
      for (let i = 0; i < members.length; i++) {
        let member = members[i];
        const recieverUserChats = await getDoc(
          doc(db, "userChats", member.uid)
        );
        if (!recieverUserChats.exists()) {
          await setDoc(doc(db, "userChats", data.user.uid), {
            [data.chatId]: {
              userInfo: {
                uid: currentUser.uid,
                displayName: currentUser.displayName,
                photoURL: currentUser.photoURL,
              },
              date: serverTimestamp(),
              lastMessage: {
                text,
              },
            },
          });
        } else {
          await updateDoc(doc(db, "userChats", member.uid), {
            [data.chatId + ".lastMessage"]: {
              text,
            },
            [data.chatId + ".date"]: serverTimestamp(),
          });
        }
      }
      setText("");
      setImg(null);
      return;
    }
    await updateDoc(doc(db, "userChats", currentUser.uid), {
      [data.chatId + ".lastMessage"]: {
        text,
      },
      [data.chatId + ".date"]: serverTimestamp(),
      [data.chatId + ".userInfo"]: {
        uid: data.user.uid,
        displayName: data.user.displayName,
        photoURL: data.user.photoURL,
      },
    });
    const recieverUserChats = await getDoc(doc(db, "userChats", data.user.uid));
    if (!recieverUserChats.exists()) {
      await setDoc(doc(db, "userChats", data.user.uid), {
        [data.chatId]: {
          userInfo: {
            uid: currentUser.uid,
            displayName: currentUser.displayName,
            photoURL: currentUser.photoURL,
          },
          date: serverTimestamp(),
          lastMessage: {
            text,
          },
        },
      });
    } else {
      await updateDoc(doc(db, "userChats", data.user.uid), {
        [data.chatId]: {
          userInfo: {
            uid: currentUser.uid,
            displayName: currentUser.displayName,
            photoURL: currentUser.photoURL,
          },
          lastMessage: { text },
          date: serverTimestamp(),
        },
      });
    }

    setText("");
    setImg(null);
  };

  const editor = useRef(null);
  const config = {
    toolbarButtonSize: "xsmall",
    spellcheck: true,
    minHeight: 100,
    width: "50vw",
    style: {
      background: "#27272E",
      color: "rgba(255,255,255,0.5)",
    },
    removeButtons: [
      "s",
      "fullsize",
      "left",
      "center",
      "right",
      "justify",
      "|",
      "undo",
      "redo",
      "|",
      "hr",
      "table",
      "font",
      "fontsize",
      "brush",
      "paragraph",
      "|",
    ],
  };

  return (
    <div className="input">
      <input
        type="text"
        placeholder="Type something..."
        onChange={(e) => setText(e.target.value)}
        value={text}
      />
      <div className="inputContent">
        <input
            type="file"
            id="file"
            accept="image/jpeg, image/png"
            style={{ display: "none" }}
            onChange={(e) => setImg(e.target.files[0])}
          />
          <label htmlFor="file" style={{ display: "flex", flexDirection: "column",alignItems: "center",fontSize: "0.7rem",color: "#838282",fontWeight: "bold"}}>
            {img ? (
              <img
                src={URL.createObjectURL(img)}
                alt="image"
                height={20}
                width={20}
                style={{
                  width:"100%",
                  borderRadius:"2px",
                  border: "1px solid #838282",
                  objectFit: "contain",
                  marginRight: "5px",
                  cursor: 'pointer',
                }}
              />
            ) : (
              <AddPhotoAlternateOutlined className="icon" />
            )}
            {img ? "Change" : "Add"}
             </label>
        <button onClick={handleSend}>Send</button>
      </div>
    </div>
  );
}
